import Repository from '../Repository';

const baseUrl = process.env.VUE_APP_API_URL;
const base = `${baseUrl}/log`;

export default {
  /**
   * Returns the Logs. Can be filtered
   *
   * @returns {Promise<T | never>}
   */
  get(filters) {
    return Repository.post(`${base}/view`, filters);
  },
};
